import styled from "styled-components"

export const Submit_ = styled.div`
    background-color:rgb(208,248,249);
    position:absolute;
    height:100%;
    width:100%;
`
export const User_form_div = styled.div`
    display:flex;
    
    padding:20px;
`
export const User_form_section = styled.div`
    margin:10px auto auto auto;
    
    width:44%;
    display:flex;
    flex-direction:column;
`
export const User_title_section = styled.div`
    background-color:white;
    border-top:8px solid #0072bc;
    border-radius:8px;
    padding:15px 25px;
    text-transform:capitalize;
    margin-bottom:8px;
`
export const User_form_questions = styled.div`
background-color:white;
border-radius:8px;
padding:30px 25px;
text-transform:capitalize;
margin-bottom:8px;
`
export const Form_check = styled.div`
`
export const Form_check_input = styled.input`
`
export const User_form_submit = styled.div`
    float:left;
`

export const User_footer = styled.div`
bottom:0;
text-align:center;
font-size:medium;
font-weight:500;
`
